import { VueConstructor } from 'vue'
import { Store } from 'vuex'
import Router from 'vue-router'
import { installVue2Buefy } from './buefy'
import { installVue2Idle } from './vue2Idle'
import { installVue2InputPlugins } from './vue2InputPlugins'
import { installVue2Moment } from './vue2Moment'
import { installVue2UtilityPlugins } from './vue2UtilityPlugins'

export function installVue2Plugins<TState>(Vue: VueConstructor, router: Router, store: Store<TState>) {
    installVue2Moment(Vue)
    installVue2Buefy(Vue)
    installVue2InputPlugins(Vue)
    installVue2UtilityPlugins(Vue, router)
    installVue2Idle(Vue, router, store)
}
